import React, { Fragment } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import Link from 'components/Link';
import breakpoint from 'styled-components-breakpoint';
import IconPlane from './assets/icon-plane.svg';
import IconRocket from './assets/icon-rocket.svg';
import Button from './Button';
import { isMobile } from 'react-device-detect';
import { get } from 'js-cookie';

const Info = styled.div`
  text-align: center;
  margin-top: 167px;
`;

const InfoTitle = styled.h2`
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
  margin-bottom: 24px;
  padding: 0 20px;

  ${breakpoint('tablet')`
    font-size: 46px;
    letter-spacing: 0.5px;
    line-height: 105%;
    padding: 0;
  `};
`;

const InfoSubtitle = styled.p`
  font-weight: 400;
  font-size: 23px;
  line-height: 30px;
  letter-spacing: 0.7px;
  color: #000000;
  margin-bottom: 71px;
  padding: 0 20px;

  ${breakpoint('tablet')`
    font-size: 28px;
    line-height: 19px;
    letter-spacing: 0.7px;
    padding: 0;
  `};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${breakpoint('desktop')`
    justify-content: center;
    flex-direction: row;
  `};
`;

const Card = styled.div`
  position: relative;
  background-color: #fff;
  min-height: 566px;
  height: auto;
  box-shadow: 0px 38.6624px 54.6022px -8.4786px rgba(0, 0, 0, 0.1);
  padding: 31px 52px 110px 52px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  &:not(:last-of-type) {
    margin-bottom: 50px;
  }

  margin-left: 20px;
  margin-right: 20px;
  max-width: calc(100% - 40px);
  width: calc(100% - 40px);
  min-width: auto;
  max-width: 360px;

  ${breakpoint('desktop')`
    min-width: 360px;
    width: 360px;
    margin-bottom: 0 !important;
    padding: 31px 52px;
    height: 566px;
    &:not(:last-of-type) {
        margin-right: 90px;
    }
  `};

  /* Gradient border */
  border-radius: 50px;
  border: 3px solid #2757f4;
  &:before {
    content: '';
    border: 5px solid #fff;
    border-top: none;
    position: absolute;
    bottom: -4px;
    left: -4px;
    border-bottom-left-radius: 50px;
    border-bottom-right-radius: 50px;
    height: 510px;
    width: calc(100% - 2px);
  }
  &:after {
    content: '';
    border-width: 3px;
    border-style: solid;
    -webkit-border-image: -webkit-gradient(
        linear,
        0 0,
        0 100%,
        from(#2757f4),
        to(rgba(0, 0, 0, 0))
      )
      1 100%;
    -webkit-border-image: -webkit-linear-gradient(#2757f4, rgba(0, 0, 0, 0)) 1
      100%;
    -moz-border-image: -moz-linear-gradient(#2757f4, rgba(0, 0, 0, 0)) 1 100%;
    -o-border-image: -o-linear-gradient(#2757f4, rgba(0, 0, 0, 0)) 1 100%;
    border-image: linear-gradient(to bottom, #2757f4, rgba(0, 0, 0, 0)) 1 100%;
    position: absolute;
    left: -3px;
    bottom: 140px;
    height: 365px;
    width: 100%;
  }
`;

const Title = styled.h3`
  z-index: 1;
  position: relative;
  font-weight: 700;
  font-size: 25px;
  line-height: 111%;
  letter-spacing: 1.5px;
  color: #000000;
`;

const Subtitle = styled.p`
  z-index: 1;
  position: relative;
  font-size: 22px;
  line-height: 24px;
  letter-spacing: 0.2px;
  color: #2756f5;
  margin-bottom: 0;
`;

const Icon = styled.i`
  position: relative;
  width: 56px;
  min-width: 56px;
  height: 56px;
  min-height: 56px;
  display: block;
  margin-top: 40px;
  margin-bottom: 27px;

  &.icon-plane {
    &:before {
      background-image: url(${IconPlane});
    }
  }
  &.icon-rocket {
    &:before {
      background-image: url(${IconRocket});
    }
  }

  &:before {
    content: '';
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    width: 56px;
    height: 56px;
  }
`;

const Price = styled.p`
  z-index: 1;
  position: relative;
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  color: #333333;
  margin-bottom: 29px;
`;

const List = styled.ul`
  z-index: 1;
  position: relative;
  list-style-type: disc;
`;

const ListItem = styled.li`
  z-index: 1;
  position: relative;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.2px;
  color: #333333;
`;

const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 34px;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Tariffs = ({ subscriptionIsActive }) => {
  return (
    <Fragment>
      <Info>
        <InfoTitle id="tariffs">
          <FormattedMessage
            id="homeredesign.tariffs.infotitle"
            defaultMessage="Тарифы 999 business"
          />
        </InfoTitle>
        <InfoSubtitle>
          <FormattedMessage
            id="homeredesign.tariffs.infosubtitle"
            defaultMessage="Откройте больше инструментов и возможностей на сайте для своего аккаунта"
          />
        </InfoSubtitle>
      </Info>
      <Wrapper>
        <Card>
          <Title>Pro</Title>
          <Subtitle>
            <FormattedMessage
              id="homeredesign.tariffs.subtitle1"
              defaultMessage="физические лица"
            />
          </Subtitle>
          <Icon className="icon-plane" />
          <Price>
            29{' '}
            <FormattedMessage
              id="homeredesign.tariffs.price1"
              defaultMessage="леев/месяц"
            />
          </Price>
          <List>
            <ListItem>
              <FormattedMessage
                id="homeredesign.tariffs.listitem1.1"
                defaultMessage="В 2 раза больше фото и тегов, до 20 000 символов в описании."
              />
            </ListItem>
            <ListItem>
              <FormattedMessage
                id="homeredesign.tariffs.listitem1.2"
                defaultMessage="Расширенный авторепубликатор."
              />
            </ListItem>
            <ListItem>
              <FormattedMessage
                id="homeredesign.tariffs.listitem1.3"
                defaultMessage="Доступ к актуальным поисковым трендам, ценам и аналитике 999."
              />
            </ListItem>
            <ListItem>
              <FormattedMessage
                id="homeredesign.tariffs.listitem1.4"
                defaultMessage="Расширенная статистика объявлений."
              />
            </ListItem>
            <ListItem>
              <FormattedMessage
                id="homeredesign.tariffs.listitem1.5"
                defaultMessage="Финансовые отчеты."
              />
            </ListItem>
            <ListItem>
              <FormattedMessage
                id="homeredesign.tariffs.listitem1.6"
                defaultMessage="Перевод средств между 2 аккаунтами"
              />
            </ListItem>
          </List>
          <ButtonWrapper>
            <Link to="/subscribe/pro/payment/">
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  if (!subscriptionIsActive) {
                    /* GA event */
                    (window.dataLayer || []).push({
                      event: 'business_activate',
                      action: 'start',
                      location: 'business_999',
                      button_location: 'activate',
                    });
                  }
                }}
                className="active"
              >
                <FormattedMessage
                  id="tarif.plan2.activate"
                  defaultMessage="Активировать"
                />
              </Button>
            </Link>
          </ButtonWrapper>
        </Card>
        <Card>
          <Title>Premium</Title>
          <Subtitle>
            <FormattedMessage
              id="homeredesign.tariffs.subtitle2"
              defaultMessage="юридические лица"
            />
          </Subtitle>
          <Icon className="icon-rocket" />
          <Price>
            <FormattedMessage
              id="homeredesign.tariffs.price2"
              defaultMessage="Бесплатно"
            />
          </Price>
          <List>
            <ListItem>
              <FormattedMessage
                id="homeredesign.tariffs.listitem2.1"
                defaultMessage="В 2 раза больше фото и тегов, до 20 000 символов в описании."
              />
            </ListItem>
            <ListItem>
              <FormattedMessage
                id="homeredesign.tariffs.listitem2.2"
                defaultMessage="Расширенный авторепубликатор."
              />
            </ListItem>
            <ListItem>
              <FormattedMessage
                id="homeredesign.tariffs.listitem2.3"
                defaultMessage="Доступ к актуальным поисковым трендам, ценам и аналитике 999."
              />
            </ListItem>
            <ListItem>
              <FormattedMessage
                id="homeredesign.tariffs.listitem2.4"
                defaultMessage="Расширенная статистика объявлений."
              />
            </ListItem>
            <ListItem>
              <FormattedMessage
                id="homeredesign.tariffs.listitem2.5"
                defaultMessage="Финансовые отчеты."
              />
            </ListItem>
            <ListItem>
              <FormattedMessage
                id="homeredesign.tariffs.listitem2.6"
                defaultMessage="Ручное или автоматическое управление обьявлениями"
              />
            </ListItem>
          </List>
          <ButtonWrapper>
            <Link to="/subscribe/business/">
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  if (!subscriptionIsActive) {
                    /* GA event */
                    (window.dataLayer || []).push({
                      event: 'business_activate',
                      action: 'start',
                      location: 'business_999',
                      button_location: 'activate',
                    });
                  }
                }}
                className="active"
              >
                <FormattedMessage
                  id="tarif.plan2.activate"
                  defaultMessage="Активировать"
                />
              </Button>
            </Link>
          </ButtonWrapper>
        </Card>
      </Wrapper>
    </Fragment>
  );
};

export default Tariffs;



// WEBPACK FOOTER //
// ./src/routes/Home/Tariffs.js